import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EditAbsenceDialogComponent } from 'src/app/my-sedgwick';
import { CsvParams, CsvService, FormatPipe, srSpeak } from 'src/app/shared';
import { CalendarEvent } from 'src/app/shared/models/CalendarEvent';
import {
  AbsenceService,
  IncidentalAbsence,
  IncidentalAbsenceReason,
} from '../..';
import { ConfigurationService } from '../../services/configuration.service';
import { AbsenceDeleteDialogComponent } from './absence-delete-dialog.component';
import { ActivityService } from '../../services/activity.service';
import { AbsenceEditDialogComponent } from './absence-edit-dialog.component';
import { IncidentalWorkScheduleDialogComponent } from '../Incidental/incidental-work-schedule-dialog.component';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-absence-grid',
    providers: [FormatPipe],
    template: `
    <div class="tw-w-full tw-flex tw-flex-wrap">
      <div class="tw-w-full" [hidden]="!showButtons">
        <mat-button-toggle-group
          name="displayMode"
          aria-label="Display Mode"
          value="list"
          #displayMode="matButtonToggleGroup"
          >
          <mat-button-toggle
            value="list"
            (change)="onValChange($event.value)"
            aria-label="Select to format absences in a list"
            ><mat-icon aria-label="Select to format absences in a list"
            >list</mat-icon
            ></mat-button-toggle
            >
            <mat-button-toggle
              value="calendar"
              (change)="onValChange($event.value)"
              aria-label="Select to format absences in a calendar layout"
              ><mat-icon
              aria-label="Select to format absences in a calendar layout"
              >date_range</mat-icon
              ></mat-button-toggle
              >
            </mat-button-toggle-group>
          </div>
    
          @if (searchEnabled) {
            <div class="app-pl2 tw-w-full md:tw-w-[20%]"></div>
          }
    
          @if (searchEnabled) {
            <div class="app-pl2 tw-w-full md:tw-w-[20%]">
              <mat-form-field>
          	<mat-label>{{ 'From' | translation: translationRequest }}</mat-label>
                <input matInput [matDatepicker]="fromDate" />
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="fromDate"
                ></mat-datepicker-toggle>
                <mat-datepicker #fromDate></mat-datepicker>
              </mat-form-field>
            </div>
          }
          @if (searchEnabled) {
            <div class="app-pl1 tw-w-full md:tw-w-[20%]">
              <mat-form-field>
          	<mat-label>{{ 'To' | translation: translationRequest }}</mat-label>
                <input matInput [matDatepicker]="toDate" />
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="toDate"
                ></mat-datepicker-toggle>
                <mat-datepicker #toDate></mat-datepicker>
              </mat-form-field>
            </div>
          }
          @if (searchEnabled) {
            <div
              class="app-pl1 app-pt1 tw-w-full md:tw-w-[20%]"
              >
              <app-button emphasis="High" label="Apply"></app-button>
              <app-button emphasis="Low" label="Clear"></app-button>
            </div>
          }
        </div>
        <app-loading-panel
          [state]="absencesLoading ? 'Loading' : 'Loaded'"
          [width]="90"
          >
          <ng-template #content>
            @if (displayMode.value === 'calendar') {
              <div>
                <div class="app-pt2"></div>
                <app-calendar
                  [events]="calendarevents"
                  toolbarRight="dayGridMonth,dayGridWeek,dayGridDay"
                  >
                </app-calendar>
                @if (isIncidentalAbsence4Feature) {
                  <div
                    class="tw-w-full tw-flex tw-flex-row app-pt2"
                    >
	            <div class=" md:tw-w-[20%] tw-flex dotAllign">
	              <div class="dot tw-bg-[var(--sed-status-green-color)]"></div>
	              <div class="app-pr2 app-pl1 tw-font-bold">{{ 'Approved' | translation: translationRequest }}</div>
	            </div>
	            <div class=" md:tw-w-[20%] tw-flex dotAllign">
	              <div class="dot tw-bg-[var(--sed-status-blue-color)]"></div>
	              <div class="app-pr2 app-pl1 tw-font-bold">{{ 'Pending' | translation: translationRequest }}</div>
	            </div>
	            <div class=" md:tw-w-[20%] tw-flex dotAllign">
	              <div class="dot tw-bg-[var(--sed-status-red-color)]"></div>
	              <div class="app-pr2 app-pl1 tw-font-bold">{{ 'Denied' | translation: translationRequest }}</div>
	            </div>
                  </div>
                }
              </div>
            }
    
            @if (displayMode.value === 'list') {
              <div
                class="tw-flex tw-flex-wrap app-pt2"
                >
                <app-list
                  class="tw-w-full"
                  [dataSource]="absences"
                  [template]="row"
                  [filterEnabled]="filterEnabled"
                  [exportEnabled]="true"
                  exportButtonAriaLabel="Export and download these absence/s as a XLSX file"
                  [noDataIcon]="noDataIcon"
                  [noDataMessage]="noDataMessage"
                  [noDataThinMessage]="noDataThinMessage"
                  [toastInfoMessage]="toastInfoMessage"
                  [displayInfoToastMsg]="displayInfoToastMsg"
                  (export)="export()"
                  [tableAriaLabel]="'Absences'"
                  >
                  <ng-container header>
                    <tr class="tw-flex tw-flex-wrap tw-w-full ">
                      <app-list-header
                        name="lastName"
                        label="Name"
                        class="tw-w-full md:tw-w-[22%]"
                        [names]="['firstName', 'lastName', 'empId']"
                      ></app-list-header>
                      <app-list-header
                        name="absenceReason"
                        label="Reason"
                        class="tw-w-full md:tw-w-[18%]"
                      ></app-list-header>
                      <app-list-header
                        [names]="['absenceStartDate', 'absenceStartTime']"
                        name="absenceStartDate"
                        label="Start"
                        class="tw-w-full md:tw-w-[15%]"
                        filterType="Date"
                      ></app-list-header>
                      <app-list-header
                        [names]="['absenceEndDate', 'absenceEndTime']"
                        name="absenceEndDate"
                        label="End"
                        class="tw-w-full md:tw-w-[15%]"
                        filterType="Date"
                      ></app-list-header>
                      <app-list-header
                        name="estimatedRTWDate"
                        label="Detail"
                        class="tw-w-full md:tw-w-[23%]"
                        [names]="['referenceNumber', 'estimatedRtw', 'shifts']"
                      ></app-list-header>
                      <app-list-header
                        name="action"
                        label="Actions"
                        class="tw-w-full md:tw-w-[5%]"
                        [ngClass]="isActionEnable ? 'tw-block' : 'tw-hidden'"
                        [sortEnabled]="false"
                      ></app-list-header>
                    </tr>
                  </ng-container>
                </app-list>
              </div>
            }
            <ng-template #row let-element>
              <tr class="tw-flex tw-flex-wrap tw-w-full ">
                <td class="tw-w-full md:tw-w-[22%]">
                  <app-value label="Name" layout="row-xs" [valueTemplate]="nameTpl">
                    <ng-template #nameTpl>
                      <div>
                        @if (employeeLinkEnabled) {
                          <a
                            routerLink=""
                      (click)="
                        absenceService.navigateToAbsences(
                          element.empId,
                          element.firstName + ' ' + element.lastName,
                          element.hrMasterUid || '',
                          element.empUnum,
                          element.encryptedEmpId
                        )
                      "
                            >
                            <b>
                              {{ element.firstName }} {{ element.lastName }} -
                              {{ element.empId }}</b
                              >
                            </a>
                          } @else {
                            <b
                              >{{ element.firstName }} {{ element.lastName }} -
                              {{ element.empId }}</b
                              >
                            }
                          </div>
                        </ng-template>
                      </app-value>
                    </td>
                    <td class="tw-w-full md:tw-w-[18%]">
                      <app-value
                        label="Reason"
                        layout="row-xs"
                        [tabindex]="element.absenceReason ? '0' : '-1'"
                        [valueTemplate]="reasonTpl"
                        >
                        <ng-template #reasonTpl>
                          <div>
                            <div class="tw-w-full">
                              {{
	                        (element.absenceReason +
	                          (showReasonSubtype ? ' - ' + element.typeOfCallOff : '')) | translation: translationRequest
                              }}
                            </div>
                          </div>
                        </ng-template>
                      </app-value>
                    </td>
                    <td class="tw-w-full md:tw-w-[15%]">
                      <app-value
                        label="Start"
                        [tabindex]="element.absenceStartDate ? '0' : '-1'"
                        layout="row-xs"
	                [value]="
	                  showTimeStamp
	                    ? (element.absenceStartDate | format : 'dateTime')
	                    : (element.absenceStartDate | format : 'date')
	                "
	                [translationNeeded]="false"
                        >
                      </app-value>
                    </td>
                    <td class="tw-w-full md:tw-w-[15%]">
                      <app-value
                        [tabindex]="element.absenceEndDate ? '0' : '-1'"
                        label="End"
                        layout="row-xs"
	                [value]="
	                  showTimeStamp
	                    ? (element.absenceEndDate | format : 'dateTime')
	                    : (element.absenceEndDate | format : 'date')
	                "
	                [translationNeeded]="false"
                        >
                      </app-value>
                    </td>
    
                    <td class="tw-w-full md:tw-w-[25%] pmt-header-init">
                      <app-value
                        [tabindex]="'0'"
                        label="Detail"
                        labelStyle="pmt-header-init"
                        layout="row-xs"
                        [valueTemplate]="detailTpl"
                        >
                        <ng-template #detailTpl>
                          <div>
                            @if (!isIncidentalAbsence4Feature) {
                              <div class="tw-w-full">
                                <b class="tw-w-full">Reference: </b>
                                {{ element.referenceNumber }}
                              </div>
                            }
                            @if (isIncidentalAbsence4Feature) {
                              <div class="tw-w-full">
                                <b class="tw-w-full">Absence Number: </b>
                                {{ element.absenceNumber }}
                              </div>
                            }
                            <div class="tw-w-full">
                              <b>Return Date: </b>
                              {{
                              showTimeStamp
                              ? (element.estimatedRTWDate | format : 'dateTime')
                              : (element.estimatedRTWDate | format : 'date')
                              }}
                            </div>
                            @if (element.shiftsMissed) {
                              <div class="tw-w-full">
                    		<b>{{ 'Work Days Absent' | translation: translationRequest }}: </b>{{ element.shiftsMissed }}
                              </div>
                            }
                            @if (element.duration) {
                              <div class="tw-w-full">
                    	        <b>{{ 'Duration' | translation: translationRequest }}: </b>{{ element.duration | translation: translationRequest }}
                              </div>
                            }
                            @if (element.absenceStatus && isIncidentalAbsence4Feature) {
                              <div
                                class="tw-w-full"
                                >
                    		  <b>{{ 'Status' | translation: translationRequest }}: </b>{{ element.absenceStatus | translation: translationRequest }}
                              </div>
                            }
                          </div>
                        </ng-template>
                      </app-value>
                    </td>
    
                    <app-value
                      class="tw-w-full md:tw-w-[5%]"
                      label="Actions"
                      layout="row-xs"
                      [ngClass]="isActionEnable === true ? 'tw-block' : 'tw-hidden'"
                      [valueTemplate]="actionsTpl"
                      >
                      <ng-template #actionsTpl>
                        <app-icon-button
                          *ngIf="isActionEnable"
                          mat-icon-button
                          icon="more_vert"
                          label="Actions"
	                  [ariaLabelTextNoTranslation] = "' - ' + element.firstName +
	                    ' ' +
	                    element.lastName +
	                    ' absence'"
	                  [attr.aria-label]="
	                    'Actions menu for'
	                    "
                          [matMenuTriggerFor]="actionMenu"
                          [attr.aria-expanded]="isActionsMenuExpanded"
                          tabindex="0"
                          role="button"
                          (click)="toggleMenu()"
                          (keydown.enter)="toggleMenu()"
                          >
                        </app-icon-button>
                        <mat-menu
                          #actionMenu="matMenu"
                          role="menu"
                          (closed)="toggleMenu()"
                          >
                          @if (showEditOption) {
                            <button
                              mat-menu-item
                              (click)="openEditAbsencePopup(element)"
                              >
                              <mat-icon>open_in_new</mat-icon>
                  	      <span>{{ 'Edit' | translation: translationRequest }}</span>
                            </button>
                          }
                          @if (showRemoveOption) {
                            <button
                              mat-menu-item
                              (click)="openRemoveAbsencePopup(element)"
                              >
                              <mat-icon>highlight_off</mat-icon>
                              <span>{{ 'Remove' | translation: translationRequest }}</span>
                            </button>
                          }
                          @if (showWorkSchedule) {
                            <button
                              mat-menu-item
                              (click)="openWorkSchedulePopup(element)"
                              >
                              <mat-icon>list_alt</mat-icon>
                  	      <span>{{ 'Work Schedule' | translation: translationRequest }}</span>
                            </button>
                          }
                        </mat-menu>
                      </ng-template>
                    </app-value>
                  </tr>
                </ng-template>
              </ng-template>
            </app-loading-panel>
    `,
    styles: [
        `
      .heading-vtop {
        vertical-align: top;
      }
      .dot {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        display: inline-block;
      }

      @media (max-width: 480px) {
        .dot {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          display: inline-block;
        }
      }

      @media (max-width: 350px) {
        .dotAllign {
          padding-left: 37%;
          text-align: center;
        }
      }
    `,
    ],
    standalone: false
})
export class AbsenceGridComponent implements OnInit {
  @Input()
  absences: IncidentalAbsence[];

  @Input()
  absencesLoading: boolean = true;

  @Input()
  reasonData: IncidentalAbsenceReason[];

  calendarevents: CalendarEvent[] = [];

  @Input()
  searchEnabled: boolean = false;

  @Input()
  employeeLinkEnabled: boolean = true;

  @Input()
  showButtons: boolean = true;

  @Input()
  filterEnabled: boolean = false;

  @Input()
  noDataIcon: string = 'search';

  @Input()
  noDataMessage: string = 'There are no absences.';

  @Input()
  noDataThinMessage: string = '';

  isActionEnable: boolean = true;

  @Input()
  toastInfoMessage: string = '';

  @Input()
  displayInfoToastMsg: boolean = false;

  @Input()
  ownAbsence: boolean = false;

  @Input()
  translationRequest: TranslationRequest;

  isActionsMenuExpanded: boolean = false;

  showTimeStamp: boolean = true;
  showReasonSubtype: boolean = true;
  isIncidentalAbsence4Feature: boolean = false;
  showRemoveOption: boolean = false;
  showWorkSchedule: boolean = false;
  showEditOption: boolean = true;
  isIncidentalAbsence5Feature: boolean = false;

  constructor(
    public dialog: MatDialog,
    private csvService: CsvService,
    private config: ConfigurationService,
    public absenceService: AbsenceService,
    private activityService: ActivityService,
    private formatpipe: FormatPipe
  ) {}

  async ngOnInit() {

    /* National Grid Feature */
    this.isIncidentalAbsence4Feature =
      await this.config.getConfigFeatureAccessAsync('IncidentalAbsence');

    /* Pepsico Feature */
    this.isIncidentalAbsence5Feature =
      await this.config.getConfigFeatureAccessAsync('IncidentalAbsences5');

    /* Has some action item Edit / Remove / Work Schedule - Nat Grid Feature*/  
    this.isActionEnable =
    (await this.config.getConfigFeatureAccessAsync('ownupdateincidentalabsences5') && this.ownAbsence) ||
      (await this.config.getConfigFeatureAccessAsync('UpdateIncidentalAbsences5') && !this.ownAbsence) 
      || this.isIncidentalAbsence4Feature;



    this.showWorkSchedule = this.isIncidentalAbsence4Feature;

    /* National Grid show Edit/Remove for managers only 
     * Pepsico Feature show Edit/Remove baseed on feature*/

    this.showRemoveOption =
    (this.isIncidentalAbsence4Feature && !this.ownAbsence) ||
     (!this.isIncidentalAbsence4Feature && this.isActionEnable)
      ? true
      : false;

    this.showEditOption =
      (this.isIncidentalAbsence4Feature && !this.ownAbsence) ||
      (!this.isIncidentalAbsence4Feature && this.isActionEnable)
        ? true
        : false;

    this.showTimeStamp = this.showReasonSubtype =
      !this.isIncidentalAbsence4Feature;

    this.activityService.alertSelected.subscribe((sub: string) => {
      this.absences = this.absences.filter((_) => _.absenceNumber !== sub);
    });
  }

  async onValChange(value: any) {
    if (value == 'calendar') {
      this.calendarevents = [];
      this.calendarevents = await this.absenceService.generateEventsFromAbsence(
        this.absences
      );
    }
  }

  async export() {
    // Format dates for export (DD/MM/YYYY when using translations / locale)
    const formatDateForExport = (value: any) =>
      value ? this.formatpipe.transform(value, 'date') || '' : '';

    const formattedRows = (this.absences || []).map((row: any) => {
      const item = { ...row };
      item.absenceStartDate = formatDateForExport(row.absenceStartDate);
      item.absenceEndDate = formatDateForExport(row.absenceEndDate);
      item.estimatedRTWDate = formatDateForExport(row.estimatedRTWDate);
      return item;
    });

    const csvParams = new CsvParams();
    csvParams.includeTimeWithDates = true;
    csvParams.rows = formattedRows;
    if (this.isIncidentalAbsence4Feature) {
      csvParams.keys = [
        'firstName',
        'lastName',
        'empId',
        'absenceReason',
        'absenceStartDate',
        'absenceEndDate',
        'absenceNumber',
        'estimatedRTWDate',
        'duration',
        'absenceStatus',
      ];
      csvParams.headers = [
        'First Name',
        'Last Name',
        'Employee Id',
        'Reason',
        'Start',
        'End',
        'Absence Number',
        'Return Date',
        'Duration',
        'Status',
      ];
      csvParams.keysToTranslate = ['duration', 'absenceStatus', 'absenceReason'];
    } else {
      csvParams.keys = [
        'firstName',
        'lastName',
        'empId',
        'absenceReason',
        'typeOfCallOff',
        'absenceStartDate',
        'absenceEndDate',
        'absenceNumber',
        'estimatedRTWDate',
        'shiftsMissed',
      ];
      csvParams.headers = [
        'First Name',
        'Last Name',
        'Employee Id',
        'Reason',
        'Secondary Reason',
        'Start',
        'End',
        'Reference',
        'Return Date',
        'Work Days Absent',
      ];
      csvParams.keysToTranslate = ['absenceReason'];
    }
    await this.csvService.download(csvParams);
  }

  openEditAbsencePopup(absence: IncidentalAbsence) {
    const dialogRef = this.isIncidentalAbsence4Feature
      ? this.dialog.open(AbsenceEditDialogComponent)
      : this.dialog.open(EditAbsenceDialogComponent);
    const instance = dialogRef.componentInstance;
    instance.dialogRef = dialogRef;
    instance.absence = absence;
    instance.reasonData = this.reasonData;
  }

  openRemoveAbsencePopup(absence: IncidentalAbsence) {
    const dialogRef = this.dialog.open(AbsenceDeleteDialogComponent);
    const instance = dialogRef.componentInstance;
    instance.dialogRef = dialogRef;
    instance.absence = absence;
  }

  openWorkSchedulePopup(absence: IncidentalAbsence) {
    const dialogRef = this.dialog.open(IncidentalWorkScheduleDialogComponent);
    const instance = dialogRef.componentInstance;
    instance.dialogRef = dialogRef;
    instance.absence = absence;
  }

  toggleMenu() {
    this.isActionsMenuExpanded = !this.isActionsMenuExpanded;
    if (this.isActionsMenuExpanded) {
      srSpeak('expanded', 'polite');
    }
  }
}
